import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScheduler = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "#748094",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "m5.832 14.168 4.09.031M10.002 10.834h4.168M17.504 7.499H2.498M6.667 2.08v2.501M13.337 2.08v2.501"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "#748094",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "M15.003 17.503H5a2.5 2.5 0 0 1-2.5-2.5V5.831a2.5 2.5 0 0 1 2.5-2.501h10.004a2.5 2.5 0 0 1 2.501 2.5v9.171a2.5 2.5 0 0 1-2.5 2.501",
		clipRule: "evenodd"
	})]
});
export default SvgScheduler;
